import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '從第一次聯繫到開始施工，通常要多久？',
    a: '一般而言，從初次諮詢到正式簽約約需 1–2 週；設計規劃階段（含概念提案與設計深化）約需 6–10 週；之後才進入施工階段。整體時程會因空間大小與工程複雜度而有所不同，我們會在初次諮詢時提供具體時程評估。',
  },
  {
    q: '我不在台灣，可以遠端進行設計合作嗎？',
    a: '可以。我們有完整的遠端合作流程，透過視訊會議、線上圖說系統與影片記錄，確保異地業主也能全程掌握設計進度。現場丈量與施工監管部分，我們會安排專員到場執行。',
  },
  {
    q: '設計費用是否包含施工工程費？',
    a: '設計費與工程費用為分開計算。設計費依空間坪數與服務範疇計費；工程費用則依材料選用、工程項目與現場條件估算，並在設計深化階段提供詳細報價清單，讓業主在決定施工前充分了解費用結構。',
  },
  {
    q: '如果設計做到一半想更改方向，怎麼辦？',
    a: '設計過程中的合理調整是正常的，我們在每個關鍵節點都安排確認程序，降低後期大幅修改的機率。若需重大方向調整，我們會評估影響範圍並與業主說明，確保溝通透明、調整有據可循。',
  },
];

export default function ProcessFaq() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-[#f4f2ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:gap-20">
          {/* Left */}
          <div className="lg:w-5/12 mb-12 lg:mb-0">
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Process FAQ</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35] mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              流程相關<br />常見問題
            </h2>
            <p className="text-[#5a5a5a] leading-relaxed mb-8" style={{ fontSize: '1.1875rem' }}>
              還有其他疑問？歡迎直接聯繫我們，
              每個案子的情況不同，我們樂意為你量身解答。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#b8956a] text-white rounded-full font-medium hover:bg-[#a07d58] transition-colors cursor-pointer whitespace-nowrap text-[1rem]"
            >
              預約免費諮詢
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right */}
          <div className="lg:w-7/12">
            <div className="flex flex-col divide-y divide-[#e2ddd8]">
              {faqs.map((f, i) => (
                <div key={i} className="py-5">
                  <button
                    className="w-full flex items-start justify-between gap-4 text-left cursor-pointer"
                    onClick={() => setOpen(open === i ? null : i)}
                  >
                    <span className="font-medium text-[#1a1a1a] leading-snug" style={{ fontSize: '1.0625rem' }}>
                      {f.q}
                    </span>
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`text-[#b8956a] transition-transform duration-300 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                    </div>
                  </button>
                  {open === i && (
                    <p className="mt-4 text-[#5a5a5a] leading-[1.75] pr-10" style={{ fontSize: '1rem' }}>
                      {f.a}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
